// Renders a Today section's task list: mobile swipe/dnd stack, or the shared
// TaskList motor (keyboard nav, F2 edit, Ctrl+Arrow reorder) on desktop.
import { useDroppable } from '@dnd-kit/core';
import {
  renderBattlefieldTodayList,
  renderDesktopTodayList,
  renderEmptySortableDropTarget,
} from '@/features/today/components/todaySectionListRenderers';

const TodaySectionList = ({
  isBattlefield,
  variant = 'simple',
  tasks,
  totalTasksCount,
  listId,
  taskType,
  leftSwipeAction = 'today',
  topActionableTaskId,
  showPlayButtonAlways = false,
  tasksMap,
  inProgressMessage,
  emptyMessage,
  selectedTaskIds,
  onSelectionChange,
  menuSurface = 'today',
  dragEnabled = false,
  dragType = null,
  swipeTeaserTaskId = null,
  onSwipeTeaserEnd,
}) => {
  const resolvedDragType = dragType ?? taskType;
  const { setNodeRef: setEmptyDropRef } = useDroppable({
    id: `${listId}-empty`,
    data: { type: resolvedDragType },
  });

  if (isBattlefield) {
    return renderBattlefieldTodayList({
      variant,
      tasks,
      totalTasksCount,
      listId,
      taskType,
      leftSwipeAction,
      topActionableTaskId,
      showPlayButtonAlways,
      tasksMap,
      inProgressMessage,
      emptyMessage,
      dragEnabled,
      dragType: resolvedDragType,
      menuSurface,
      swipeTeaserTaskId,
      onSwipeTeaserEnd,
    });
  }

  if (tasks.length > 0) {
    return renderDesktopTodayList({
      tasks,
      selectedTaskIds,
      onSelectionChange,
      topActionableTaskId,
      showPlayButtonAlways,
      menuSurface,
      variant,
      dragEnabled,
      dragType: resolvedDragType,
      taskType,
      listId,
    });
  }

  if (variant !== 'sortable') return null;

  return renderEmptySortableDropTarget({
    setEmptyDropRef,
    totalTasksCount,
    inProgressMessage,
    emptyMessage,
  });
};

export default TodaySectionList;
